import Step1PersonalInfo from "../components/RegisterSteps/Step1AccountSetup ";
import Step2AccountDetails from "../components/RegisterSteps/Step2OtpVerify";
import Step3ProfileInfo from "../components/RegisterSteps/Step3ProfileInfo";

  
  export const RegisterSteps = [
    {
      component: Step1PersonalInfo,
    
    },
    {
      component: Step2AccountDetails,
     
    },
    {
      component: Step3ProfileInfo,
    
    },
   
  ];